import React, { useState, useEffect } from 'react';
import '../css/Message.css';
import assistantIcon from '../assets/conda-white-chat.svg';
import loadingIcon from '../assets/conda-violet.svg';
import MarkdownComponent from './Markdown';
import userIcon from '../assets/user-icon.png';

function Message({ message, copilot, scrollToBottom }) {
  const [wordIndex, setWordIndex] = useState(0);
  const [displayedContent, setDisplayedContent] = useState('');
  const words = message.content.split(" ");

  useEffect(() => {
    setWordIndex(0);
  }, []);

  useEffect(() => {
    if (message.role === "user" || copilot) {
      setDisplayedContent(message.content);
    } else if (message.role === "assistant") {
      const typingSpeed = calculateTypingSpeed(message.content.length);
      
      if (wordIndex < words.length) {
        const timer = setTimeout(() => {
          setDisplayedContent((prevContent) => `${prevContent}${words[wordIndex]}`);
          setWordIndex((prevIndex) => prevIndex + 1);
        }, typingSpeed);
        return () => clearTimeout(timer);
      }
    }
  }, [wordIndex, words]);

  useEffect(() => {
    scrollToBottom();
  }, [displayedContent]);

  const calculateTypingSpeed = (messageLength) => {
    if (messageLength <= 200) {
      return 30;
    } else if (messageLength <= 400) {
      return 15;
    } else {
      return 5;
    }
  };

  const getIcon = function (role) {
    switch (role) {
      case "assistant":
        return { icon: assistantIcon, className: "assistant-icon" };
      case "user":
        return { icon: userIcon, className: "user-icon" };
      case "loading":
      case "loading_message":
        return { icon: loadingIcon, className: "loading-icon" };
      default:
        console.log('message role not exists');
        return null;
    }
  }

  if (!message || !message.role || !message.content) {
    return null;
  }

  let messageClass = "";
  const role = message.role
  switch (role) {
    case "assistant":
      messageClass = "bot-message";
      break;
    case "user":
      messageClass = "user-message";
      break;
    case "loading":
    case "loading_message":
      messageClass = "loading-message";
      break;
    default:
      console.log('message role not exists');
  }

  return (
    <>
      <div className={`message-container ${messageClass}`}>
        <img src={getIcon(message.role).icon} alt="User icon" className={getIcon(message.role).className} />

        {message.role === "loading" ? (
          <div className="dots">
            <div className="col-3">
              <div className="snippet" data-title="dot-pulse">
                <div className="stage">
                  <div className="dot-pulse"></div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <MarkdownComponent messageClass={`message ${messageClass}`} text={(displayedContent)}></MarkdownComponent>
        )}
      </div>
      <br />
    </>
  );
}

export default Message;



